function FormSubmitSuccess({ formTitle }) {
  return (
    <div className="text-center py-8">
      <div className="inline-flex items-center justify-center w-16 h-16 bg-green-100 rounded-full mb-4">
        <svg className="w-8 h-8 text-green-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
        </svg>
      </div>
      <h2 className="text-2xl font-semibold text-gray-900 mb-2">Form Submitted</h2>
      <p className="text-gray-600 mb-4">
        Your response to <strong>{formTitle}</strong> has been received.
      </p>
      <p className="text-sm text-gray-500">
        Our team will review your submission and follow up if needed. You can close this page.
      </p>
    </div>
  );
}

export default FormSubmitSuccess;
